import styled from '@emotion/styled';
import React from 'react';
var OptionalTag = function (_a) {
    var _b = _a.label, label = _b === void 0 ? '(optional)' : _b;
    return React.createElement(Tag, null, label);
};
var Tag = styled.span(function (_a) {
    var _b = _a.theme, colors = _b.colors, space = _b.space;
    return "\n    color: ".concat(colors.primary, ";\n    opacity: 50%;\n    padding-left: ").concat(space[1], ";\n");
});
export default OptionalTag;
//# sourceMappingURL=OptionalTag.js.map